module.exports = __webpack_public_path__ + "img/avatar-70.1e887080.png";